export function renderSidebar(active = '') {
  const aside = document.querySelector('aside.sidebar');
  if (!aside) return;
  const isActive = (key) => key === active ? 'active' : '';
  const aria = (key) => key === active ? 'aria-current="page"' : '';
  aside.innerHTML = `
    <button class="sidebar-close" id="sidebarClose" aria-label="Fermer le menu">
      <i class="fa-solid fa-xmark" aria-hidden="true"></i>
    </button>
    <div class="brand">
      <div class="logo-container">
        <i class="fas fa-church"></i>
      </div>
      <div class="brand-text">
        <h1>Vases d'Honneur</h1>
        <p>Assemblée Rehoboth</p>
      </div>
    </div>

    <div class="user-profile">
      <div class="avatar" id="avatar">VU</div>
      <div class="user-info">
        <h3 id="userName">Utilisateur</h3>
        <span class="badge" id="roleBadge">RESPONSABLE</span>
      </div>
    </div>

    <nav class="nav-menu" aria-label="Menu principal">
      <a href="../dashboard/dashboard.html" class="nav-item ${isActive('dashboard')}" ${aria('dashboard')}>
        <i class="fa-solid fa-gauge" aria-hidden="true"></i>
        <span>Tableau de bord</span>
      </a>
      <a href="../formulaire-adn/formulaire-adn.html" class="nav-item ${isActive('formulaire')}">
        <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
        <span>Formulaire ADN</span>
      </a>
      <a href="../adn/adn.html" class="nav-item ${isActive('adn')}" id="navADN" style="display:none;">
        <i class="fa-solid fa-clipboard-list" aria-hidden="true"></i>
        <span>Suivi ADN</span>
      </a>
      <a href="../gestion-donnees/gestion-donnees.html" class="nav-item ${isActive('data')}" id="navData" style="display:none;">
        <i class="fa-solid fa-table" aria-hidden="true"></i>
        <span>Gestion données</span>
      </a>
      <a href="../signup/signup.html" class="nav-item ${isActive('signup')}" ${aria('signup')} id="navSignup" style="display:none;">
        <i class="fa-solid fa-user-plus" aria-hidden="true"></i>
        <span>Créer un compte</span>
      </a>
    </nav>

    <div class="sidebar-footer">
      <button class="btn-logout" id="btnLogout">
        <i class="fa-solid fa-right-from-bracket"></i>
        <span>Déconnexion</span>
      </button>
    </div>
  `;
}
